import Vue from 'vue'
import VueRouter from 'vue-router'

import userRoutes from '@/router/user.js'
import eventRoutes from '@/router/event.js'
import rechercheRoutes from '@/router/recherche.js'
import dashboardRoutes from '@/router/dashboard.js'
import reportsRoutes from '@/router/reports.js'
import fundingsRoutes from '@/router/fundings.js'
import store from '@/store/index.js'
import { isAdmin } from '@/helpers/auth.js'

Vue.use(VueRouter)

const routes = [
  ...userRoutes,
  ...eventRoutes,
  ...rechercheRoutes,
  ...dashboardRoutes,
  ...reportsRoutes,
  ...fundingsRoutes,
  {
    path: '*',
    meta: {
      layout: 'empty-page',
      isAuthRequired: false
    },
    component: () => import('@/views/errorpages/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const { isAuthenticated } = store.state.user
  const { mitarbeiterId } = store.state.user.currentUser

  if (to.matched.some((record) => record.meta.isAuthRequired === false)) {
    next()
  } else {
    if (isAuthenticated) {
      next()
    } else {
      next({ name: 'login' })
    }
  }
  if (to.matched.some(record => record.meta.adminUser)) {
    if (!isAdmin(mitarbeiterId)) {
      next({ name: 'event-dashboard' })
    } else {
      next()
    }
  }
})

const DEFAULT_TITLE = 'VLAMS'
router.afterEach((to, from) => {
  Vue.nextTick(() => {
      document.title = to.meta.title || DEFAULT_TITLE
  })
})

export default router
